import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-message",
  "use": "icon-message-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-message\"><path d=\"M311.8 169.2L253.6 111C156.4 185.1 92.1 300.2 86 430.4h81.4c6.1-107.8 61.4-202.2 144.4-261.2z m544.8 261.2H938C931.9 300.2 867.6 185 770 111l-58.2 58.2c83.4 59 138.7 153.4 144.8 261.2z m-80.1 20.4c0-124.9-86.7-229.5-203.4-257.1V166c0-33.8-27.3-61-61-61-33.8 0-61 27.3-61 61v27.7c-116.8 27.7-203.4 132.2-203.4 257.1v223.8L166.3 756v40.7H858V756l-81.4-81.4V450.8zM512 918.7c5.7 0 11-0.4 16.3-1.6 26.4-5.3 48.4-23.6 58.6-48 4.1-9.8 6.5-20.3 6.5-31.7H430.6c0 44.7 36.6 81.3 81.4 81.3z m0 0\" fill=\"#c1cada\" p-id=\"3917\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/message.svg
// module id = G2zY
// module chunks = 57